import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import mathUtil from '../../util/math';
import compose from '../../hoc/compose';
import NumericInput from '../numericInput/numericInput';
import { dataHooks } from './constants';

var AngleInput = /*#__PURE__*/function (_React$Component) {
  _inherits(AngleInput, _React$Component);

  var _super = _createSuper(AngleInput);

  function AngleInput(props) {
    var _this;

    _classCallCheck(this, AngleInput);

    _this = _super.call(this, props);

    _this.circleRefCallback = function (circle) {
      _this.circle = circle;
    };

    _this.saveCircleCenter = function () {
      var boundingRectangle = _this.circle.getBoundingClientRect();

      _this.circleCenter = {
        x: boundingRectangle.left + boundingRectangle.width / 2,
        y: boundingRectangle.top + boundingRectangle.height / 2
      };
    };

    _this.changeAngle = function (e) {
      return _this.props.onChange(mathUtil.getAngleFromOrigin(_this.circleCenter, {
        x: e.pageX,
        y: e.pageY
      }));
    };

    _this.onClick = function (e) {
      e.preventDefault();

      _this.saveCircleCenter();

      _this.changeAngle(e);
    };

    _this.onKnobMouseDown = function () {
      _this.saveCircleCenter();

      window.document.addEventListener('mousemove', _this.changeAngle);
      window.document.addEventListener('mouseup', _this.onKnobMouseUp);
    };

    _this.onKnobMouseUp = function () {
      window.document.removeEventListener('mousemove', _this.changeAngle);
      window.document.removeEventListener('mouseup', _this.onKnobMouseUp);
    };

    _this.getCircleStyle = function () {
      return {
        transform: "rotate(".concat(_this.props.value, "deg)"),
        WebkitTransform: "rotate(".concat(_this.props.value, "deg)")
      };
    };

    _this.getKnobStyle = function () {
      return {
        transform: "rotate(-".concat(_this.props.value, "deg)"),
        WebkitTransform: "rotate(-".concat(_this.props.value, "deg)")
      };
    };

    return _this;
  }

  _createClass(AngleInput, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.document.removeEventListener('mousemove', this.changeAngle);
      window.document.removeEventListener('mouseup', this.onKnobMouseUp);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        className: this.props.getClassName('control-angle-input') + (this.props.disabled ? 'disabled' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "circle",
        style: this.getCircleStyle(),
        ref: this.circleRefCallback,
        onDragStart: function onDragStart(e) {
          return e.preventDefault();
        },
        onClick: this.props.disabled ? null : this.onClick
      }, /*#__PURE__*/React.createElement("div", {
        className: "circle-center"
      }), /*#__PURE__*/React.createElement("div", {
        className: "knob",
        style: this.getKnobStyle(),
        onMouseDown: this.props.disabled ? null : this.onKnobMouseDown
      })), /*#__PURE__*/React.createElement(NumericInput, {
        dataHook: dataHooks.numericInput,
        disabled: this.props.disabled,
        value: this.props.value,
        onChange: this.props.onChange,
        unit: "angle",
        min: 0,
        max: 360,
        placeholder: "placeholder"
      }));
    }
  }]);

  return AngleInput;
}(React.Component);

AngleInput.displayName = 'AngleInput';
AngleInput.propTypes = {
  /** the angle value */
  value: PropTypes.number.isRequired,

  /** a callback called with the new value when releasing the angle handle */
  onChange: PropTypes.func.isRequired,

  /** disables angle change */
  disabled: PropTypes.bool
};
AngleInput.defaultProps = {
  disabled: false
};
export default compose(AngleInput);